'use client';

import type {FC, PropsWithChildren} from 'react';
import {Disclosure} from '@headlessui/react';
import {ChevronDownIcon, ChevronUpIcon} from '@heroicons/react/20/solid';
import clsx from 'clsx';

import {type Theme, THEME_DARK, THEME_LIGHT} from '@/utils/types';

type Props = PropsWithChildren & {
	theme?: Theme;
	className?: string;
};

export const NewsletterDisclosure: FC<Props> = ({
	theme = THEME_LIGHT,
	className,
	children,
}) => {
	return (
		<Disclosure as="div" className={clsx(className)}>
			{({open}) => (
				<>
					<div
						className={clsx(
							'inline-block',
							'focus-within:ring-focus-dark',
							'rounded',
							'-my-2',
							'py-2',
							'-mx-4',
							'px-4',
						)}
					>
						<Disclosure.Button
							className={clsx(
								'flex',
								'items-end',
								'justify-between',
								'text-left',
								'gap-1',
								'border-b',
								'py-2',
								'focus-visible:ring-disabled',
								theme === THEME_LIGHT && [
									'text-forestGreen-700',
									open
										? 'border-transparent'
										: 'border-forestGreen-700',
								],
								theme === THEME_DARK && [
									'text-turquoise-700',
									open
										? 'border-transparent'
										: 'border-turquoise-700',
								],
							)}
						>
							<span
								className={clsx(
									'font-medium',
									'text-sm',
									'md:text-lg',
								)}
							>
								Samtykke
							</span>
							{open ? (
								<ChevronUpIcon
									className={clsx(
										'h-6',
										'w-6',
										'-mb-0.5',
										'md:h-7',
										'md:w-7',
										'md:ml-1',
									)}
									aria-hidden="true"
								/>
							) : (
								<ChevronDownIcon
									className={clsx(
										'h-6',
										'w-6',
										'-mb-0.5',
										'md:h-7',
										'md:w-7',
										'md:ml-1',
									)}
									aria-hidden="true"
								/>
							)}
						</Disclosure.Button>
					</div>
					<Disclosure.Panel className={clsx('w-full', 'mt-8')}>
						<p
							className={clsx(
								'text-xs',
								'font-medium',
								'md:text-bodyRegular',
								theme === THEME_LIGHT && [
									'text-forestGreen-700',
								],
								theme === THEME_DARK && ['text-turquoise-700'],
							)}
						>
							{children}
						</p>
					</Disclosure.Panel>
				</>
			)}
		</Disclosure>
	);
};
